module.exports = __webpack_public_path__ + "img/challenges.f8e41d45.png";